import { BentoGrid, BentoCell } from "@kj/design-system";
import { Users, ShieldCheck, Flag, MessageSquareWarning, HeartHandshake, TrendingUp } from "lucide-react";

const STATS = [
  { k: "users", label: "Total Users", value: "0", delta: "+0 today", tone: "primary" as const, icon: Users },
  { k: "kyc", label: "KYC Pending", value: "0", delta: "0 awaiting review", tone: "trust" as const, icon: ShieldCheck },
  { k: "reports", label: "Open Reports", value: "0", delta: "no new today", tone: "sakura" as const, icon: Flag },
  { k: "mod", label: "Flagged Messages", value: "0", delta: "AI-detected", tone: "default" as const, icon: MessageSquareWarning },
  { k: "matches", label: "Active Matches", value: "0", delta: "3rd-msg converted", tone: "primary" as const, icon: HeartHandshake },
  { k: "founding", label: "Founding Members", value: "0/1000", delta: "F1K progress", tone: "trust" as const, icon: TrendingUp },
];

export default function DashboardPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-3xl font-semibold tracking-tight">Dashboard</h1>
        <p className="text-sm text-fg-muted">
          Live KPIs for SkyToLove (pre-launch). Data connectors coming in Sprint 3.
        </p>
      </header>
      <BentoGrid>
        {STATS.map((s) => (
          <BentoCell
            key={s.k}
            tone={s.tone}
            span={s.k === "founding" ? "md" : "sm"}
            height="sm"
            eyebrow={s.label}
            icon={<s.icon className="h-4 w-4" />}
          >
            <div className="text-3xl font-bold tracking-tight mt-1">{s.value}</div>
            <div className="text-xs text-fg-muted mt-1">{s.delta}</div>
          </BentoCell>
        ))}
      </BentoGrid>
    </div>
  );
}
